import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getCategory() {
  return request({
    url: `${v2Host}/common/category/list`,
    method: 'get'
  })
}

export function getCountry() {
  return request({
    url: '/common/option/countries',
    method: 'get'
  })
}

export function getMaterialOptions() {
  return request({
    url: '/collection/material/options',
    method: 'get'
  })
}

/**
 * 获取语言列表
 * http://playable.dev.com/doc/index.php?route=Common/Option#languagesAction
 */
export function getLanguages() {
  return request({
    url: `${v2Host}/common/language/list`,
    method: 'get'
  })
}

/**
 * 获取地区列表
 */
export function getRegion() {
  return request({
    url: `${v2Host}/common/region/list`,
    method: 'get'
  })
}
